import { render } from "./FloatingSlimLayout.vue?vue&type=template&id=ed2dc4bc&scoped=true"
import script from "./FloatingSlimLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatingSlimLayout.vue?vue&type=script&setup=true&lang=js"

import "./FloatingSlimLayout.vue?vue&type=style&index=0&id=ed2dc4bc&lang=scss&scoped=true"
import "./FloatingSlimLayout.vue?vue&type=style&index=1&id=ed2dc4bc&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed2dc4bc"],['__file',"src/modules/app/layouts/FloatingSlimLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ed2dc4bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ed2dc4bc', __exports__)) {
    api.reload('ed2dc4bc', __exports__)
  }
  
  module.hot.accept("./FloatingSlimLayout.vue?vue&type=template&id=ed2dc4bc&scoped=true", () => {
    api.rerender('ed2dc4bc', render)
  })

}


export default __exports__